import { render, staticRenderFns } from "./confirmpic.vue?vue&type=template&id=0849a092&"
import script from "./confirmpic.vue?vue&type=script&lang=js&"
export * from "./confirmpic.vue?vue&type=script&lang=js&"
import style0 from "./confirmpic.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports